import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit
} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import _ from "lodash";
import {DATA_LIMIT} from "../constants/content.constant";

export {
    addSingleContentConfig,
    updateSingleContentConfig,
    getSingleContentConfig,
    searchContentConfig,
    searchContentConfigWithSearchCriteria,
    prepareContentConfigList
}

const collectionName = 'content-config';
const collectionReference = collection(fireStoreDB, collectionName);

const addSingleContentConfig = (contentConfig, contentConfigId) => {
    contentConfig.createdAt = new Date();
    contentConfig.updatedAt = contentConfig.createdAt;

    if (contentConfigId) {
        contentConfig.id = contentConfigId;
        return updateSingleContentConfig(contentConfig);
    } else {
        return addDoc(collectionReference, contentConfig);
    }
}

const updateSingleContentConfig = (contentConfig) => {
    const documentReference = doc(fireStoreDB, collectionName, contentConfig.id);
    contentConfig.updatedAt = new Date();
    return setDoc(documentReference, contentConfig);
}

const getSingleContentConfig = (contentConfigId) => {
    const documentReference = doc(fireStoreDB, collectionName, contentConfigId);
    return getDoc(documentReference);
}

const searchContentConfig = async (searchText) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery, limit(DATA_LIMIT));

    const contentConfigResult = await getDocs(searchQuery);
    return prepareContentConfigList(contentConfigResult);
}

const searchContentConfigWithSearchCriteria = async (searchCriteriaList) => {
    let searchQuery = query(collectionReference);

    // console.log('searchContentConfigWithSearchCriteria', {searchCriteriaList});

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    searchQuery = query(searchQuery, limit(DATA_LIMIT));

    const contentConfigResult = await getDocs(searchQuery);
    return prepareContentConfigList(contentConfigResult);
}

const prepareContentConfigList = (contentConfigResult) => {
    const contentConfigList = [];

    _.forEach(contentConfigResult.docs, contentConfigDoc => {
        contentConfigList.push({
            ...contentConfigDoc.data(),
            id: contentConfigDoc.id
        });
    });

    return contentConfigList;
}
